import { cva } from "class-variance-authority";

export const toggleVariants = cva(
  "hover:bg-secondary/60 hover:text-secondary-foreground data-[state=on]:bg-secondary data-[state=on]:text-secondary-foreground inline-flex items-center justify-center rounded text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "hover:bg-secondary/60 hover:text-secondary-foreground border bg-transparent",
      },
      size: {
        sm: "size-8",
        md: "size-9",
        lg: "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  },
);
